import script from "./ViewContact.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewContact.vue?vue&type=script&setup=true&lang=js"

import "./ViewContact.vue?vue&type=style&index=0&id=366fca30&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366fca30"]])

export default __exports__